import './TableStyle.scss';

import { Table } from '@tfecom-thermofisher/react-komodo-design';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { Message, Pagination, Visible } from 'src/core/components';

import AccordionContent from './AccordionContent';
import messages from './messages';

export const TableComponent = ({
  id,
  data,
  config,
  onConfigChange,
  totalItems,
  onPaginationChange,
  setPagination,
  pagination,
}) => {
  const renderRowSubComponent = ({ row }) => {
    const { original: rowOriginal } = row;
    return <AccordionContent row={row} rowOriginal={rowOriginal} />;
  };

  return (
    <>
      <Table
        data={data}
        columns={config}
        onConfigChange={onConfigChange}
        renderRowSubComponent={renderRowSubComponent}
        size="large"
        autoResetExpanded={false}
      />
      <Visible when={!data?.length}>
        <div data-testid={`${id}-table-no-data`} className="table-no-data">
          <Message message={messages.noTableDataDefault} literal />
        </div>
      </Visible>
      <Visible when={!!pagination}>
        <Pagination
          fetchNewResources={onPaginationChange}
          resourcesLength={totalItems}
          setPagination={setPagination}
          pagination={pagination}
        />
      </Visible>
    </>
  );
};

TableComponent.propTypes = {
  id: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  config: PropTypes.array.isRequired,
  onConfigChange: PropTypes.func,
  totalItems: PropTypes.number,
  onPaginationChange: PropTypes.func,
  setPagination: PropTypes.func,
  pagination: PropTypes.object,
  designDetail: PropTypes.object,
  fetchCustomDesignDetails: PropTypes.func,
};

export default injectIntl(TableComponent);
